export default function MatchStatus({ displayName, iHaveMatched, theyMatched, isMutual, isCurrentUser }) {
	if (isCurrentUser || (!iHaveMatched && !theyMatched)) return null;

	return (
		<div>
			{isMutual ? (
				<small className="text-success fw-semibold text-nowrap">
					<i className="bi bi-check-all" style={{ fontSize: "1.5rem", lineHeight: 0, verticalAlign: "top" }}></i>
					Mutual match! <i className="bi bi-whatsapp ms-1" style={{ fontSize: "0.875rem", lineHeight: 0 }}></i>
				</small>
			) : theyMatched && !iHaveMatched ? (
				<small className="my-color text-nowrap">
					<i className="bi bi-check" style={{ fontSize: "1.5rem", lineHeight: 0, verticalAlign: "top" }}></i>
					{displayName} matched you
				</small>
			) : (
				<small className="text-warning text-nowrap">
					<i className="bi bi-check" style={{ fontSize: "1.5rem", lineHeight: 0, verticalAlign: "top" }}></i>
					You matched {displayName}
				</small>
			)}
		</div>
	);
}
